import React from 'react';
import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import './SupportVisualisationScreenshot.scss';

export default function SupportVisualisationScreenshot(
    props: VisualisationContextProps
) {
    const { height, width } = props;
    const screenshot = props!.state!.screenshot!;
    const { height: imageHeight, width: imageWidth } = props!.state!.dimensions;

    return (
        <div
            className="SupportVisualisationScreenshot"
            style={{ height, width }}
        >
            <img
                src={screenshot}
                height={imageHeight}
                width={imageWidth}
                alt={'Screenshot'}
            />
        </div>
    );
}
